import { render } from "./minimum.vue?vue&type=template&id=1a2f3738&scoped=true"
import script from "./minimum.vue?vue&type=script&lang=js"
export * from "./minimum.vue?vue&type=script&lang=js"

import "./minimum.vue?vue&type=style&index=0&id=1a2f3738&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2f3738"]])

export default __exports__